import { RouteRecordRaw } from 'vue-router';

import { FilterType } from '../models/filter';
import { PortalDefinition } from '../models/definition';
import SearchResults from '../presentation/components/search-results/SearchResults.vue';
import { BaseRoutes } from './BaseRoutes';
import RoutingDefinitions from './RoutingDefinitions';

export class Routes extends BaseRoutes {
	public getRoutes(portalDefinition: PortalDefinition): RouteRecordRaw[] {
		const routes = super.getRoutes(portalDefinition);

		const degreeTypeRegex = portalDefinition.getFilterDefinition(FilterType.DEGREE_TYPE).getPathRegex();
		const disciplinesRegex = portalDefinition.getFilterDefinition(FilterType.DISCIPLINES).getPathRegex();
		const countryRegex = portalDefinition.getFilterDefinition(FilterType.COUNTRY).getPathRegex();
		const deliveryMethodRegex = portalDefinition.getFilterDefinition(FilterType.DELIVERY_METHOD).getPathRegex();
		const durationRegex = portalDefinition.getFilterDefinition(FilterType.DURATION).getPathRegex();
		const specialProgrammesRegex = portalDefinition.getFilterDefinition(FilterType.SPECIAL_PROGRAMMES).getPathRegex();
		const formatRegex = portalDefinition.getFilterDefinition(FilterType.ATTENDANCE).getPathRegex();
		const tuitionFeeRegex = portalDefinition.getFilterDefinition(FilterType.TUITION_FEE).getPathRegex();
		const degreeRegex = portalDefinition.getFilterDefinition(FilterType.DEGREE_TYPE).getPathRegex();
		const areaRegex = portalDefinition.getFilterDefinition(FilterType.AREA).getPathRegex();
		const continentRegex = portalDefinition.getFilterDefinition(FilterType.CONTINENT).getPathRegex();
		const disciplineRegex = portalDefinition.getFilterDefinition(FilterType.DISCIPLINES).getPathRegex();

		const COUNTRY_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const COUNTRY_ATTENDANCE_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_ATTENDANCE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const COUNTRY_FORMAT_ROUTE = {
			path: `:attendance(${formatRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_FORMAT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const COUNTRY_ATTENDANCE_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:delivery_method(${deliveryMethodRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_ATTENDANCE_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const COUNTRY_DEGREE_TYPE_DURATION_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:duration(${durationRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_DEGREE_TYPE_DURATION_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DISCIPLINE_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:discipline(${disciplinesRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DISCIPLINE_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting,
		};
		const ATTENDANCE_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:delivery_method(${deliveryMethodRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.ATTENDANCE_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DISCIPLINE_DEGREE_TYPE_COUNTRY_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:discipline(${disciplinesRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DISCIPLINE_DEGREE_TYPE_COUNTRY_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting,
		};
		const SPECIAL_PROGRAMMES_ROUTE = {
			path: `:special_programmes(${specialProgrammesRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.SPECIAL_PROGRAMMES_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DEGREE_TYPE_DELIVERY_METHOD_DISCIPLINE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:delivery_method(${deliveryMethodRegex})/:discipline(${disciplinesRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_DELIVERY_METHOD_DISCIPLINE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting,
		};
		const DEGREE_TYPE_COUNTRY_TUITION_FEE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:country(${countryRegex})/:tuition_fee(${tuitionFeeRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_COUNTRY_TUITION_FEE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DEGREE_TYPE_COUNTRY_DELIVERY_METHOD_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:country(${countryRegex})/:delivery_method(${deliveryMethodRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_COUNTRY_DELIVERY_METHOD_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DEGREE_ROUTE = {
			path: `:degree(${degreeRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const SPECIAL_PROGRAMMES_CONTINENT_ROUTE = {
			path: `:special_programmes(${specialProgrammesRegex})/:continent(${portalDefinition.getFilterDefinition(FilterType.CONTINENT).getPathRegex()})`,
			component: SearchResults,
			name: RoutingDefinitions.SPECIAL_PROGRAMMES_CONTINENT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const SPECIAL_PROGRAMMES_COUNTRY_ROUTE = {
			path: `:special_programmes(${specialProgrammesRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.SPECIAL_PROGRAMMES_COUNTRY_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const FORMAT_ATTENDANCE_ROUTE = {
			path: `:attendance(${formatRegex})/:delivery_method(${deliveryMethodRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.FORMAT_ATTENDANCE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const ATTENDANCE_AREA_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:country(${countryRegex})/:area(${portalDefinition.getFilterDefinition(FilterType.AREA).getPathRegex()})`,
			component: SearchResults,
			name: RoutingDefinitions.ATTENDANCE_AREA_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DEGREE_TYPE_TUITION_FEE_FORMAT_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:tuition_fee(${tuitionFeeRegex})/:attendance(${formatRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_TUITION_FEE_FORMAT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DURATION_CONTINENT_ROUTE = {
			path: `:duration(${durationRegex})/:continent(${portalDefinition.getFilterDefinition(FilterType.CONTINENT).getPathRegex()})`,
			component: SearchResults,
			name: RoutingDefinitions.DURATION_CONTINENT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const SPECIAL_PROGRAMMES_DISCIPLINE_ROUTE = {
			path: `:special_programmes(${specialProgrammesRegex})/:discipline(${disciplinesRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.SPECIAL_PROGRAMMES_DISCIPLINE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting,
		};
		const DEGREE_TYPE_FORMAT_ATTENDANCE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:attendance(${formatRegex})/:delivery_method(${deliveryMethodRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_FORMAT_ATTENDANCE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const ATTENDANCE_DISCIPLINE_COUNTRY_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:discipline(${disciplinesRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.ATTENDANCE_DISCIPLINE_COUNTRY_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting,
		};
		const FORMAT_DISCIPLINE_COUNTRY_ROUTE = {
			path: `:attendance(${formatRegex})/:discipline(${disciplinesRegex})/:country(${countryRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.FORMAT_DISCIPLINE_COUNTRY_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting,
		};
		const DEGREE_TYPE_SPECIAL_PROGRAMMES_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:special_programmes(${specialProgrammesRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_SPECIAL_PROGRAMMES_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};
		const DEGREE_TYPE_SPECIAL_PROGRAMMES_ATTENDANCE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:special_programmes(${specialProgrammesRegex})/:delivery_method(${deliveryMethodRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_SPECIAL_PROGRAMMES_ATTENDANCE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const FORMAT_ROUTE = {
			path: `:attendance(${formatRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.FORMAT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		}

		const DEGREE_FORMAT_ROUTE = {
			path: `:degree(${degreeRegex})/:attendance(${formatRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_FORMAT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		}

		const DEGREE_TUITION_FEE_DELIVERY_METHOD_ROUTE = {
			path: `:degree(${degreeRegex})/:tuition_fee(${tuitionFeeRegex})/:delivery_method(${deliveryMethodRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TUITION_FEE_DELIVERY_METHOD_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DEGREE_AREA_ROUTE = {
			path: `:degree(${degreeRegex})/:country(${countryRegex})/:area(${areaRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_AREA_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DEGREE_TUITION_FEE_ROUTE = {
			path: `:degree(${degreeRegex})/:tuition_fee(${tuitionFeeRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TUITION_FEE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DEGREE_TUITION_FEE_AREA_ROUTE = {
			path: `:degree(${degreeRegex})/:tuition_fee(${tuitionFeeRegex})/:country(${countryRegex})/:area(${areaRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TUITION_FEE_AREA_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DEGREE_CONTINENT_ROUTE = {
			path: `:degree(${degreeRegex})/:continent(${continentRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_CONTINENT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const TUITION_FEE_DELIVERY_METHOD_ROUTE = {
			path: `:tuition_fee(${tuitionFeeRegex})/:delivery_method(${deliveryMethodRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.TUITION_FEE_DELIVERY_METHOD_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DELIVERY_METHOD_DURATION_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:duration(${durationRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DELIVERY_METHOD_DURATION_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DELIVERY_METHOD_DISCIPLINE_CONTINENT_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:discipline(${disciplineRegex})/:continent(${continentRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DELIVERY_METHOD_DISCIPLINE_CONTINENT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DEGREE_TYPE_TUITION_FEE_CONTINENT_ROUTE = {
			path: `:degree(${degreeRegex})/:tuition_fee(${tuitionFeeRegex})/:continent(${continentRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_TUITION_FEE_CONTINENT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const FORMAT_DELIVERY_METHOD_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:attendance(${formatRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.FORMAT_DELIVERY_METHOD_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DELIVERY_METHOD_CONTINENT_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:continent(${continentRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DELIVERY_METHOD_CONTINENT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const FORMAT_CONTINENT_ROUTE = {
			path: `:attendance(${formatRegex})/:continent(${continentRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.FORMAT_CONTINENT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		const DEGREE_TYPE_DURATION_ROUTE = {
			path: `:degree(${degreeRegex})/:duration(${durationRegex})`,
			component: SearchResults,
			name: RoutingDefinitions.DEGREE_TYPE_DURATION_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter,
		};

		routes.push(
			DEGREE_TYPE_SPECIAL_PROGRAMMES_ATTENDANCE_ROUTE,
			DEGREE_TYPE_TUITION_FEE_FORMAT_ROUTE,
			DEGREE_TYPE_FORMAT_ATTENDANCE_ROUTE,
			ATTENDANCE_DISCIPLINE_COUNTRY_ROUTE,
			FORMAT_DISCIPLINE_COUNTRY_ROUTE,
			COUNTRY_DEGREE_TYPE_ROUTE,
			COUNTRY_ATTENDANCE_ROUTE,
			COUNTRY_FORMAT_ROUTE,
			COUNTRY_ATTENDANCE_DEGREE_TYPE_ROUTE,
			COUNTRY_DEGREE_TYPE_DURATION_ROUTE,
			DISCIPLINE_DEGREE_TYPE_ROUTE,
			DISCIPLINE_DEGREE_TYPE_COUNTRY_ROUTE,
			ATTENDANCE_DEGREE_TYPE_ROUTE,
			SPECIAL_PROGRAMMES_CONTINENT_ROUTE,
			SPECIAL_PROGRAMMES_COUNTRY_ROUTE,
			SPECIAL_PROGRAMMES_DISCIPLINE_ROUTE,
			DEGREE_TYPE_SPECIAL_PROGRAMMES_ROUTE,
			DURATION_CONTINENT_ROUTE,
			FORMAT_ATTENDANCE_ROUTE,
			ATTENDANCE_AREA_ROUTE,
			SPECIAL_PROGRAMMES_ROUTE,
			DEGREE_TYPE_DELIVERY_METHOD_DISCIPLINE_ROUTE,
			DEGREE_TYPE_COUNTRY_TUITION_FEE_ROUTE,
			DEGREE_TYPE_COUNTRY_DELIVERY_METHOD_ROUTE,
			DEGREE_ROUTE,
			FORMAT_ROUTE,
			DEGREE_FORMAT_ROUTE,
			DEGREE_TUITION_FEE_DELIVERY_METHOD_ROUTE,
			DEGREE_AREA_ROUTE,
			DEGREE_TUITION_FEE_ROUTE,
			DEGREE_TUITION_FEE_AREA_ROUTE,
			DEGREE_CONTINENT_ROUTE,
			TUITION_FEE_DELIVERY_METHOD_ROUTE,
			DELIVERY_METHOD_DURATION_ROUTE,
			DELIVERY_METHOD_DISCIPLINE_CONTINENT_ROUTE,
			DEGREE_TYPE_TUITION_FEE_CONTINENT_ROUTE,
			FORMAT_DELIVERY_METHOD_ROUTE,
			DELIVERY_METHOD_CONTINENT_ROUTE,
			FORMAT_CONTINENT_ROUTE,
			DEGREE_TYPE_DURATION_ROUTE
		);

		return routes;
	}
}
